import axios from 'Src/helpers/api/axiosInstance';
import { AppUser } from 'Src/views/App/App';
import { DEFAULT_LIMIT, DEFAULT_SKIP } from 'Src/consts/table';

type Filter = { where?: any; skip?: number; limit?: number; order?: string };

export function getSchoolUnionTournamentTeamPlayers(
  user: AppUser,
  ownerSchoolId: string,
  tournamentId: string,
  teamId: string,
  filter?: Filter,
  contextSchoolId?: string,
  options: { includeEvents?: boolean } = {}
) {
  const { roleSessionKey: key } = user;
  const normalizedFilter = {
    ...filter,
    limit: filter?.limit ?? DEFAULT_LIMIT,
    skip: filter?.skip ?? DEFAULT_SKIP
  };
  const config = {
    headers: { usid: key },
    params: {
      includeEvents: options.includeEvents === false ? false : undefined,
      filter: {
        where: normalizedFilter.where,
        skip: normalizedFilter.skip,
        limit: normalizedFilter.limit,
        order: normalizedFilter.order
      }
    }
  };
  return axios
    .get(
      `${(window as any).apiBase}/i/schools/${ownerSchoolId}/tournaments/${tournamentId}/teams/${teamId}/players`,
      config
    )
    .then(r => r.data);
}

export function getSchoolUnionTournamentTeamPlayersCount(
  user: AppUser,
  ownerSchoolId: string,
  tournamentId: string,
  teamId: string,
  where?: any,
  contextSchoolId?: string
) {
  const { roleSessionKey: key } = user;
  const config = { headers: { usid: key }, params: { filter: { where } } };
  return axios
    .get(
      `${(window as any).apiBase}/i/schools/${ownerSchoolId}/tournaments/${tournamentId}/teams/${teamId}/players/count`,
      config
    )
    .then(r => r.data);
}

export function updateSchoolUnionTournamentTeamPlayersBatch(
  user: AppUser,
  ownerSchoolId: string,
  tournamentId: string,
  teamId: string,
  data: { add?: Array<{ userId: string; permissionId?: string }>; remove?: string[] }
) {
  const { roleSessionKey: key } = user;
  const config = { headers: { usid: key } };
  return axios
    .post(
      `${(window as any).apiBase}/i/schools/${ownerSchoolId}/tournaments/${tournamentId}/teams/${teamId}/players/batch`,
      data,
      config
    )
    .then(r => r.data);
}

export interface TournamentTeamPlayerQuantumNumberData {
  quantumPlayerNumber: number | null;
}

export type AssignTournamentTeamPlayerNumbersMode = 'FILL_MISSING' | 'RENUMBER_ALL';

export interface AssignTournamentTeamPlayerNumbersData {
  startFrom: number;
  endAt?: number;
  mode?: AssignTournamentTeamPlayerNumbersMode;
}

export function getSchoolUnionTournamentTeam(
  user: AppUser,
  ownerSchoolId: string,
  tournamentId: string,
  teamId: string
) {
  const { roleSessionKey: key } = user;

  const config = {
    headers: { usid: key }
  };

  return axios
    .get(
      `${(window as any).apiBase}/i/schools/${ownerSchoolId}/tournaments/${tournamentId}/teams/${teamId}`,
      config
    )
    .then(r => r.data);
}

export function updateSchoolUnionTournamentTeamPlayerQuantumNumber(
  user: AppUser,
  ownerSchoolId: string,
  tournamentId: string,
  teamId: string,
  playerId: string,
  data: TournamentTeamPlayerQuantumNumberData
) {
  const { roleSessionKey: key } = user;

  const config = {
    headers: { usid: key }
  };

  return axios
    .put(
      `${(window as any).apiBase}/i/schools/${ownerSchoolId}/tournaments/${tournamentId}/teams/${teamId}/players/${playerId}`,
      data,
      config
    )
    .then(r => r.data);
}

export function assignSchoolUnionTournamentTeamPlayerNumbersToTeam(
  user: AppUser,
  ownerSchoolId: string,
  tournamentId: string,
  teamId: string,
  data: AssignTournamentTeamPlayerNumbersData
) {
  const { roleSessionKey: key } = user;

  const config = {
    headers: { usid: key }
  };

  return axios
    .put(
      `${(window as any).apiBase}/i/schools/${ownerSchoolId}/tournaments/${tournamentId}/teams/${teamId}/players/assignQuantumNumbers`,
      data,
      config
    )
    .then(r => r.data);
}

export function assignSchoolUnionTournamentTeamPlayerNumbersToTournament(
  user: AppUser,
  ownerSchoolId: string,
  tournamentId: string,
  data: AssignTournamentTeamPlayerNumbersData
) {
  const { roleSessionKey: key } = user;

  const config = {
    headers: { usid: key }
  };

  return axios
    .put(
      `${(window as any).apiBase}/i/schools/${ownerSchoolId}/tournaments/${tournamentId}/players/assignQuantumNumbers`,
      data,
      config
    )
    .then(r => r.data);
}
